module.exports = __webpack_public_path__ + "img/txt_info1.dd51f2ba.png";